export default __webpack_public_path__ + "static/hero-hand-babf87752889543ad38d0f4b69b6f59a.png";